var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"man-tgx-dash wrapper",scopedSlots:_vm._u([{key:"default",fn:function(dashProps){return [_c('div',{staticClass:"dashboard game-connected yes",style:({
        transform:
          'scale(' + dashProps.currentScale + ') translate(-50%, -50%)',
        width: dashProps.skinData.size.width + 'px',
        height: dashProps.skinData.size.height + 'px'
      })},[_c('div',{staticClass:"hasJob",class:{ yes: _vm.telemetry.job.cargo.id }},[_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-speed',
            type: 'meter',
            value: _vm.telemetry2.truck.speed,
            min: _vm.$convertToUnit(2.77778, 'unit_speed'),
            max: _vm.$convertToUnit(34.7222, 'unit_speed'),
            minAngle: -120,
            maxAngle: 103
          },false)),_c('div',{staticClass:"truck-speedRounded wrapper-area"},[_c('span',[_vm._v(_vm._s(_vm.telemetry2.truck.speed.toFixed(0)))])]),_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-engineRpm',
            type: 'meter',
            value: _vm.telemetry.truck.engine.rpm.value / 100,
            min: 2,
            max: 32,
            minAngle: -119,
            maxAngle: 122
          },false)),_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-fuel',
            type: 'meter',
            value: _vm.telemetry.truck.fuel.value,
            min: 0,
            max: _vm.telemetry.truck.fuel.capacity,
            minAngle: -28,
            maxAngle: 30
          },false)),_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-waterTemperature',
            type: 'meter',
            value: _vm.telemetry.truck.engine.waterTemperature.value,
            min: 0,
            max: 100,
            minAngle: -48,
            maxAngle: 27
          },false)),_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-airPressure',
            type: 'meter',
            value: _vm.$pressureToBar(_vm.telemetry.truck.brakes.airPressure.value),
            min: 0,
            max: 12,
            minAngle: -30,
            maxAngle: 25
          },false)),_c('Cadran',_vm._b({},'Cadran',{
            classCSS: 'truck-oilPressure',
            type: 'meter',
            value: _vm.$pressureToBar(_vm.telemetry.truck.engine.oilPressure.value),
            min: 0,
            max: 12,
            minAngle: -34,
            maxAngle: 25
          },false)),_c('div',{staticClass:"truck-odometer wrapper-area"},[_c('span',[_vm._v(_vm._s(_vm.unit_length(_vm.telemetry.truck.odometer, 'km', true, false).toFixed(0)))])]),_c('div',{staticClass:"truck-gear wrapper-area"},[_c('span',[_vm._v(_vm._s(_vm.telemetry2.truck.gearDisplayed))])]),_c('div',{staticClass:"truck-blinkerLeftOn",class:{ yes: _vm.telemetry.truck.lights.blinker.left.active }}),_c('div',{staticClass:"truck-blinkerRightOn",class:{ yes: _vm.telemetry.truck.lights.blinker.right.active }}),_c('div',{staticClass:"truck-cruiseControlOn",class:{ yes: _vm.telemetry.truck.cruiseControl.enabled }}),_c('div',{staticClass:"truck-lightsBeamHighOn",class:{ yes: _vm.telemetry.truck.lights.beamHigh.enabled }}),_c('div',{staticClass:"truck-lightsBeamLowOn",class:{ yes: _vm.telemetry.truck.lights.beamLow.enabled }}),_c('div',{staticClass:"truck-lightsParkingOn",class:{ yes: _vm.telemetry.truck.lights.parking.enabled }}),_c('div',{staticClass:"trailer-mass wrapper-area"},[_c('span',[_vm._v(_vm._s(_vm.unit_weight(_vm.telemetry.job.cargo.mass, true, false).toFixed(0))),_c('span',{staticClass:"ton"},[_vm._v(_vm._s(_vm.unit_weight(_vm.telemetry.job.cargo.mass, false)))])])]),_c('div',{staticClass:"truck-parkBrakeOn",class:{ yes: _vm.telemetry.truck.brakes.parking.enabled }}),_c('div',{staticClass:"truck-airPressureWarningOn",class:{ yes: _vm.telemetry.truck.brakes.airPressure.warning.enabled }}),_c('div',{staticClass:"truck-retarderBrake"},[_vm._v(" "+_vm._s(_vm.$t(_vm.telemetry.truck.brakes.retarder.level > 0 ? 'On' : 'Off'))+" ")]),_c('div',{staticClass:"truck-oilTemperature"},[_vm._v(" "+_vm._s(_vm.unit_degrees(_vm.telemetry.truck.engine.oilTemperature.value))+" ")]),_c('div',{staticClass:"truck-batteryVoltage"},[_vm._v(" "+_vm._s(_vm.telemetry.truck.engine.batteryVoltage.warning.factor.toFixed(0))+" ")]),_c('div',{staticClass:"game-time wrapper-area"},[_c('span',[_vm._v(_vm._s(_vm.$dateTimeLocalized( _vm.telemetry2.gameTime, _vm.DATE_FORMAT_SHORT, _vm.TIME_FORMAT_SHORT )))])]),_c('div',{staticClass:"truck-airPressureEmergencyOn",class:{ yes: _vm.telemetry.truck.brakes.airPressure.emergency.enabled }})],1)])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }